/**
 * PREVIEW COMPANY ENTRY POINT
 *
 * The preview company page shows the available articles for a non active entity
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import reduxStore from './../../reduxStore';
import utils from './../../utils/utilities';

import actions from './PreviewCompany.actions';

import headerActions from './../../reusable/Header/Header.actions';
import reviewActions from './../ReviewCompanies/ReviewCompanies.actions';
import PreviewTable from './template/PreviewCompany.previewTable.jsx';
import PreviewPanel from './template/PreviewCompany.panel.jsx';
import PreviewCounterActivatedEntities from './template/PreviewCompany.previewCounterActivatedEntities.jsx';
import PreviewPagination from './template/PreviewCompany.previewPagination.jsx';
import { PESTLEContentCell } from './../../reusable/CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';
import ViewArticleWithNavigation from './../../reusable/PreviewArticle/ViewArticleWithNavigation';
import { hashHistory } from 'react-router';
import PreviewCompanyArticleTable from './components/PreviewCompanyArticleTable';

import {
    DateContentCell,
    TitleCellNoLink,
    LanguageCell
} from './../../reusable/CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';


export default class PreviewCompany extends React.Component {

    constructor(props) {
        super(props);

        this.state = reduxStore.getState().previewCompany;
        this.state.urlParams.language = reduxStore.getState().user.preferences.articlesLanguageFilter;
        this.state.columnWidths = this.props.isEmbeddedComponent ? [40, 18, 10, 32] : [46, 15, 15, 24];

        this.table = null;
        this.tableId = 'preview-companies-table';
        this.categoryOptions = [];
        this.rowsModel = [];
        this.panelTopPosition = 0;

        // this.sortByLanguage = this.sortByLanguage.bind(this);
        this.sortByDate = this.sortByDate.bind(this);
        this.handleChangeLoadParams = this.handleChangeLoadParams.bind(this);
        this.handleClickArticle = this.handleClickArticle.bind(this);
        this.resetEditCompanyPanel = this.resetEditCompanyPanel.bind(this);
        this.finishedAddingEntries = this.finishedAddingEntries.bind(this);
        this.sortByRiskAngle = this.sortByRiskAngle.bind(this);
        this.sortByRiskLevel = this.sortByRiskLevel.bind(this);
        this.filterByLanguage = this.filterByLanguage.bind(this);
        this.activateAndShowNextCompany = this.activateAndShowNextCompany.bind(this);
        this.refreshCompanyData = this.refreshCompanyData.bind(this);
        this.showRefreshDialog = this.showRefreshDialog.bind(this);
        this.hideRefreshDialog = this.hideRefreshDialog.bind(this);
        this.resetRefreshDialog = this.resetRefreshDialog.bind(this);
        this.toggleEditCompanyPanelFixed = this.toggleEditCompanyPanelFixed.bind(this);
        this.toggleDialogPopupFixed = this.toggleDialogPopupFixed.bind(this);
        this.calculatePanelPosition = this.calculatePanelPosition.bind(this);
        this.calculateDialogPosition = this.calculateDialogPosition.bind(this);
        this.getInactiveEntitiesCount = this.getInactiveEntitiesCount.bind(this);

        this.moveToArticle = this.moveToArticle.bind(this);
        this.buildArticleLink = this.buildArticleLink.bind(this);
        this.goToEditEntity = this.goToEditEntity.bind(this);

        this.rowsModel = [
            {
                fieldId:   'articleId',
                fieldType: TitleCellNoLink,
                props:     {
                    clickHandler: this.buildArticleLink
                }
            },
            {
                fieldId:   'language',
                fieldType: LanguageCell
            },
            {
                fieldId:   'harvestDate',
                fieldType: DateContentCell,
                classes:   'notranslate'
            },
            {
                fieldId:   'pestleCategories',
                fieldType: PESTLEContentCell,
                format:    (value) => utils.parsePestleResponse(value)
            }
        ];

    }

    componentDidMount() {

        this.getInactiveEntitiesCount();

        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState().previewCompany);
            }
        );

        if (!this.props.isEmbeddedComponent) {
            headerActions.updateHeader('previewCompany');
            actions.loadCompany(this.props.params.companyId);
        }

        if (this.props.params.articleId) {
            if (this.props.params.backRoute === 'edit-third-party') {
                headerActions.updateHeader('previewArticleFromEdit');
            } else {
                headerActions.updateHeader('previewArticle');
            }
        }

        reviewActions.populateNextPrev(this.props.params.companyId);

        if (!this.props.params.articleId) {
            window.addEventListener('scroll', this.toggleEditCompanyPanelFixed);
            window.addEventListener('resize', this.toggleEditCompanyPanelFixed);

            window.addEventListener('scroll', this.toggleDialogPopupFixed);
            window.addEventListener('resize', this.toggleDialogPopupFixed);
        }

        // Scrolls top to prevent the issue of the scrollbar remaining at the same position from the previous page
        window.scrollTo(0, 0);

        if (this.props.params.articleId) {
            let arr =[];
            arr.push({articleId: parseInt(this.props.params.articleId, 10)});
        }

    }

    componentWillUnmount() {

        this.unsubscribe();

        if (!this.props.params.articleId) {
            window.removeEventListener('scroll', this.toggleEditCompanyPanelFixed);
            window.removeEventListener('resize', this.toggleEditCompanyPanelFixed);

            window.removeEventListener('scroll', this.toggleDialogPopupFixed);
            window.removeEventListener('resize', this.toggleDialogPopupFixed);
        }

        actions.resetPreviewToInitial();

    }

    componentWillReceiveProps(nextProps) {

        if (this.props.params.articleId) {
            if (this.props.params.backRoute === 'edit-third-party') {
                headerActions.updateHeader('previewArticleFromEdit');
            } else {
                headerActions.updateHeader('previewArticle');
            }
        }

        // This component changes its state via the URL params.
        // When the company is switched via next/previous or activate and show next we want the article page to be reset
        // In case of viewing articles we want to reset only when returning to the Preview Company Page
        if (this.props.params.companyId !== nextProps.params.companyId || (!nextProps.params.articleId && this.props.params.articleId)) {
            actions.countShownEntries(null, null);
        }

        if (!this.props.isEmbeddedComponent) {

            // Used in Preview Page

            if (this.props.params.companyId !== nextProps.params.companyId) {

                /* Only reset edit panel, refresh dialog and add buttons
                 * if they are available (you're NOT on an article page)
                 */
                if (!this.props.params.articleId) {

                    this.resetEditCompanyPanel();
                    this.resetRefreshDialog();

                }

                actions.loadCompany(nextProps.params.companyId);
                reviewActions.populateNextPrev(nextProps.params.companyId);

            }

            if (nextProps.params.articleId && nextProps.params.articleId !== this.props.params.articleId) {
                window.removeEventListener('scroll', this.toggleEditCompanyPanelFixed);
                window.removeEventListener('resize', this.toggleEditCompanyPanelFixed);
            }

        } else {

            // Recalculate the edit panel position in case the user closes or opens the About section
            if (nextProps.togglePanelPositionUpdate !== this.props.togglePanelPositionUpdate) {
                this.calculatePanelPosition(true);
            }

            if (nextProps.params.articleId && nextProps.params.articleId !== this.props.params.articleId) {
                window.removeEventListener('scroll', this.toggleEditCompanyPanelFixed);
                window.removeEventListener('resize', this.toggleEditCompanyPanelFixed);
            }

        }

    }

    buildArticleLink(event, articleId, articleIndex) {
        if (this.props.isEmbeddedComponent) {
            let companyData = reduxStore.getState().editThirdParty.companyData;
            let location = window.location.href.substr(window.location.href.indexOf('#/') + 2);


            let config = {};
            config.headerKey = "editThirdParty";
            config.ttl = companyData.companyTitle;
            config.url = '/api/entities/preview/' + this.props.params.companyId;
            config.urlParams = this.state.urlParams;
            config.backRoute = location;
            config.hideTitle = !this.props.isEmbeddedComponent;
            config.injectEntity = this.props.params.companyId;
            config.articleCount=this.state.filterCount;
            config.embeddedResultList="articleList";

            hashHistory.push('/view-article/' + articleId + '/' + articleIndex + '?config=' + encodeURIComponent(JSON.stringify(config)));

        } else {
            hashHistory.push('/preview-company/' + this.props.params.companyId +"/" + articleId + '/' + articleIndex + '/preview-company');
        }
    }

    moveToArticle(articleId, articleIndex) {
        hashHistory.push('preview-company/' + this.props.params.companyId +"/" + articleId + '/' + articleIndex +'/preview-company');
    }

    sortByDate() {

        let urlParams = Object.assign(
            {},
            this.state.urlParams,
            {
                sortBy:    'date',
                direction: this.state.urlParams.direction === 'asc' && this.state.urlParams.sortBy === 'date'
                    ? 'desc' : 'asc'
            }
        );
        actions.changeTableUrlParams(urlParams);
    }

    sortByRiskAngle(event) {

        let riskAngle = event.target.value;

        actions.countShownEntries(null, null);
        let urlParams = Object.assign(
            {},
            this.state.urlParams,
            {riskAngle: riskAngle}
        );
        actions.changeTableUrlParams(urlParams);
    }

    sortByRiskLevel(event) {

        let riskLevel = event.target.value;

        actions.countShownEntries(null, null);

        let urlParams = Object.assign(
            {},
            this.state.urlParams,
            {riskLevel: riskLevel}
        );
        actions.changeTableUrlParams(urlParams);
    }

    filterByLanguage(event) {
        let language = event.target.value;

        actions.countShownEntries(null, null);

        actions.changeTableUrlParams(Object.assign(
            {},
            this.state.urlParams,
            {language: language}
        ));
    }

    finishedAddingEntries(response) {

        let count = response.body && typeof response.body.totalCount === 'number' ? response.body.totalCount : 'N/A';
        let filterCount = response.body && typeof response.body.filterCount === 'number' ? response.body.filterCount :
            'N/A';

        actions.countShownEntries(count, filterCount);
    }

    activateAndShowNextCompany() {

        let panel = document.getElementsByClassName("preview-company__panel")[0];
        let refreshDialog = document.getElementsByClassName("refresh-dialog")[0];
        panel ? this.resetEditCompanyPanel() : null;
        refreshDialog ? this.resetRefreshDialog() : null;

        reviewActions.activateAndShowNextCompany(
            this.props.params.companyId,
            {
                nextCompany:     this.state.nextCompany,
                previousCompany: this.state.previousCompany
            }
        ).then(() => {
            this.getInactiveEntitiesCount();
        }).catch((error) => {
            utils.logError(error, 'PreviewCompany.activateAndShowNextCompany():');
        });

    }

    calculatePanelPosition(forceUpdate = false) {
        let panel = document.getElementsByClassName('preview-company__panel')[0];

        if (panel && (!this.panelTopPosition || forceUpdate)) {
            this.panelTopPosition = window.pageYOffset + panel.getBoundingClientRect().top;
        }
    }

    calculateDialogPosition(forceUpdate = false) {
        let dialog = document.getElementsByClassName('refresh-dialog')[0];

        if (dialog && (!this.dialogTopPosition || forceUpdate)) {
            this.dialogTopPosition = window.pageYOffset + dialog.getBoundingClientRect().top;
        }
    }

    toggleDialogPopupFixed() {
        // Prevent this handler from being triggered when the Search parameters section is closed on Edit Entity page,
        // or if the table is shorter than the min-height on the table
        let table = document.getElementById('preview-companies-table');
        if(!table) {
            return;
        }

        if (table.getBoundingClientRect().height < 400) {
            return;
        } else if (this.props.isPanelAlwaysVisible && !this.props.isSearchSectionOpened) {
            return;
        }

        let dialog          = document.getElementsByClassName('refresh-dialog')[0],
            dialog_pop      = document.getElementsByClassName('refresh-dialog__popup')[0],
            scrolledFromTop = window.scrollY || window.pageYOffset;


        if (dialog.classList.contains('shown')) {
            this.calculateDialogPosition(true);
        }

        if (dialog.classList.contains('shown') && scrolledFromTop > this.dialogTopPosition) {
            dialog_pop.classList.add('fixed');
        }

        if (dialog_pop.classList.contains('fixed') && scrolledFromTop < this.dialogTopPosition) {
            dialog_pop.classList.remove('fixed');
        }

    }

    toggleEditCompanyPanelFixed() {

        // Prevent this handler from being triggered when the Search parameters section is closed on Edit Entity page
        if (this.props.isEmbeddedComponent && !this.props.isSearchSectionOpened) {
            return;
        }

        let panel           = document.getElementsByClassName('preview-company__panel')[0],
            scrolledFromTop = window.scrollY || window.pageYOffset;

        if (!panel.classList.contains('fixed') && scrolledFromTop > this.panelTopPosition) {
            panel.classList.add('fixed');
        }

        if (panel.classList.contains('fixed') && scrolledFromTop < this.panelTopPosition) {
            panel.classList.remove('fixed');
        }

    }

    resetEditCompanyPanel(withInputsReset = true, staysShown = false) {
        let panel = document.getElementsByClassName("preview-company__panel")[0];
        let table = document.getElementsByClassName("infinite-scroll-table")[0];
        let dialog = document.getElementsByClassName("refresh-dialog")[0];

        if (withInputsReset) {
            panel.reset();
        }

        if (staysShown) {
            panel.classList.remove('fixed');
        } else {
            panel.className = 'preview-company__panel';
            table.className = 'infinite-scroll-table';
        }

        dialog.className = 'refresh-dialog';
    }

    refreshCompanyData() {

        //resets countBox data (to show spinner) until new data comes in
        actions.countShownEntries(null, null);

        // Reload company data
        actions.loadCompany(this.state.currentCompany, true).then(() => {

            if (this.props.isEmbeddedComponent) {
                this.resetEditCompanyPanel(false, true);
            }

            // Refresh table data
            let urlParams = Object.assign(
                {},
                this.state.urlParams,
                {
                    refreshToggle: this.state.urlParams.refreshToggle === 0 ? 1 : 0
                }
            );
            actions.changeTableUrlParams(urlParams);
        });

        this.hideRefreshDialog();
    }

    showRefreshDialog() {
        let refreshDialog  = document.getElementsByClassName("refresh-dialog")[0],
            table          = document.getElementsByClassName("infinite-scroll-table")[0],
            collapsedClass = table.classList.contains('collapse') ? ' collapse' : '';

        refreshDialog.className = "refresh-dialog shown" + collapsedClass;
    }

    hideRefreshDialog() {
        let refreshDialog = document.getElementsByClassName("refresh-dialog")[0];
        refreshDialog.classList.remove("shown");
    }

    resetRefreshDialog() {
        let refreshDialog = document.getElementsByClassName("refresh-dialog")[0];
        refreshDialog.className = "refresh-dialog";
    }

    getInactiveEntitiesCount() {

        let reviewState = reduxStore.getState().reviewCompanies;
        if (reviewState.selectedItems.length === 0 ) {
             if (reviewState.previewItems.length === 0) {
                 //refreshing with F5 in preview all or preview selected items
                 // will clear selectedItems and previewItems, so it's set to "x of 1"
                 actions.countEntries(1);
             } else {
                 actions.countEntries();
             }
        } else {
            actions.countEntries(reviewState.previewItems.length);
        }

    }

    goToEditEntity() {
        hashHistory.push('/edit-third-party/' + this.props.params.companyId);
    }

    handleChangeLoadParams(filters, sorting) {
        actions.changeTableUrlParams({ ...this.state.urlParams, ...utils.loadParamsToUrlParams({ filters, sorting }) });
    }

    handleClickArticle(article, index) {
        this.buildArticleLink(null, article.articleId, index)
    }

    handleDataUpdate(articles, totalCount, filterCount) {
        actions.countShownEntries(totalCount, filterCount);
    }

    render() {

        let companyData = reduxStore.getState().editThirdParty.companyData;

        let title            = companyData ? companyData.companyTitle : null,
            articlesTableUrl = this.state.currentCompany ?
            '/api/entities/preview/' + this.state.currentCompany : null,
            table            = null;

        if (articlesTableUrl) {
            table = (
                <div className="preview-company__table">

                    <div className="refresh-dialog">

                        <div className="refresh-dialog__popup">
                            <div className="refresh-dialog__popup--header">
                                <FormattedMessage id="Entities_Preview_UIText_previewCompanies.changesSaved" />
                            </div>
                            <div className="refresh-dialog__popup--edited-search">
                                <FormattedMessage id="Entities_Preview_UIText_previewCompanies.editedSearchTerms" />
                            </div>
                            <div className="refresh-dialog__popup--click-refresh">
                                <FormattedMessage id="Entities_Preview_UIText_previewCompanies.clickRefresh" />
                            </div>
                            <div className="refresh-dialog__popup--button">
                                <button className="button-primary-lg refresh"
                                        onClick={this.refreshCompanyData}>
                                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.refresh" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <PreviewTable ref="previewCompanyTable"
                                  tableId={this.tableId}
                                  columnWidths={this.state.columnWidths}
                                  rowsModel={this.rowsModel}
                                  categoryOptions={this.categoryOptions}
                                  userActions={
                                      {
                                          sortByDate:                 this.sortByDate,
                                          sortByRiskAngle:            this.sortByRiskAngle,
                                          sortByRiskLevel:            this.sortByRiskLevel,
                                          filterByLanguage:           this.filterByLanguage
                                      }
                                  }
                                  url={articlesTableUrl}
                                  urlParams={this.state.urlParams}
                                  lifecycleEvents={
                                      {
                                          finishedAddingEntries: this.finishedAddingEntries
                                      }
                                  }
                                  count={this.state.articleCount}
                                  filterCount={this.state.filterCount} />

                    {/*
                    This is the new table, it will be needed later on
                    <PreviewCompanyArticleTable key={this.props.params.companyId} // to remount when company id changes
                                                entityId={this.props.params.companyId}
                                                {...utils.urlParamsToLoadParams(this.state.urlParams)}
                                                onChangeParams={this.handleChangeLoadParams}
                                                onClickArticle={this.handleClickArticle}
                                                onDataUpdate={actions.countShownEntries}/>*/}
                </div>
            );
        }

        let content = null;

        if (this.props.params.articleId && title) {

            content = (
                <ViewArticleWithNavigation
                    articleId={this.props.params.articleId}
                    articleIndex={parseInt(this.props.params.articleIndex, 10)}
                    backRoute={"preview-company/" + this.props.params.companyId}
                    injectEntity={this.props.params.companyId}
                    title={title}
                    hideTitle={!this.props.isEmbeddedComponent}
                    url={articlesTableUrl}
                    urlParams={this.state.urlParams}
                    articleCount={this.state.filterCount}
                    moveToArticle={this.moveToArticle}
                    embeddedResultList="articleList"
                />
            );
        } else if (!this.props.params.articleId) {
            content = (
                <div className="preview-company__panel-table">
                    <div className="preview-company__panel-container">

                        <PreviewPanel showRefreshDialog={this.showRefreshDialog}
                                      toggleEditCompanyPanel={
                                          this.props.isEmbeddedComponent ? null : this.toggleEditCompanyPanel
                                      } />

                    </div>
                    {table}
                </div>
            );
        }

        return (
            <div className="preview-company-page">
                {this.props.isEmbeddedComponent || this.props.params.backRoute === 'edit-third-party' ?
                    null : (
                        <div>
                            <PreviewCounterActivatedEntities activateAndShowNextCompany={this.activateAndShowNextCompany}
                                                             previewEntitiesCount={this.state.previewEntitiesCount}/>
                            <div className="preview-company-details">
                                <PreviewPagination previousCompanyId={this.state.previousCompany}
                                                   nextCompanyId={this.state.nextCompany}
                                                   previewEntitiesCount={this.state.previewEntitiesCount}
                                                   currentCompany={this.state.currentCompany}
                                                   route={this.props.params.backRoute}/>

                                <div className="notranslate preview-company-details__title">
                                    <h2>{title}</h2>
                                </div>

                                {this.props.params.articleId ?
                                    null

                                    :

                                    <button
                                        className="button-doc-sm preview-company-details__edit-button"
                                        onClick={this.goToEditEntity}>
                                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.editCompany" />
                                        <span className="la-TriangleRight"></span>
                                    </button>
                                }
                            </div>
                        </div>
                    )
                }

                {content}

            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/PreviewCompany/PreviewCompany.index.jsx